import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import {
  LayoutDashboard, Users, BookOpen, GraduationCap, Layers,
  Newspaper, ShoppingBag, Settings, LogOut, Heart, UserCog
} from 'lucide-react';
import { toast } from 'sonner';

const menuItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/admin' },
  { icon: UserCog, label: 'Manajemen Akun', path: '/admin/akun' },
  { icon: Users, label: 'Data Santri', path: '/admin/santri' },
  { icon: GraduationCap, label: 'Data Guru', path: '/admin/guru' },
  { icon: Layers, label: 'Halaqah', path: '/admin/halaqah' },
  { icon: Newspaper, label: 'BQ News', path: '/admin/berita' },
  { icon: ShoppingBag, label: 'Toko ZahBaq', path: '/admin/toko' },
  { icon: Heart, label: 'Program Donasi', path: '/admin/donasi' },
  { icon: Settings, label: 'Pengaturan', path: '/admin/settings' },
];

export default function AdminSidebar() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    toast.success('Berhasil keluar');
    navigate('/welcome');
  };

  return (
    <aside
      data-testid="admin-sidebar"
      className="w-14 md:w-64 min-h-screen bg-white border-r border-emerald-50 flex flex-col shadow-card flex-shrink-0"
      style={{ position: 'sticky', top: 0, height: '100vh' }}
    >
      {/* Logo */}
      <div className="p-3 md:p-5 border-b border-emerald-50">
        <div className="flex items-center justify-center md:justify-start gap-3">
          <img src="/logo-zahbaq.png" alt="ZahBaq" className="w-8 h-8 md:w-10 md:h-10 object-contain flex-shrink-0" />
          <div className="hidden md:block">
            <h1 className="font-playfair font-bold text-emerald-900 text-lg leading-tight">ZahBaq</h1>
            <p className="text-[10px] text-emerald-600 font-medium">Admin Panel</p>
          </div>
        </div>
      </div>

      {/* Menu */}
      <nav className="flex-1 p-2 md:p-4 space-y-1 overflow-y-auto">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              data-testid={`sidebar-${item.label.toLowerCase().replace(' ', '-')}`}
              onClick={() => navigate(item.path)}
              title={item.label}
              className={`w-full flex items-center gap-3 px-2 md:px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200 justify-center md:justify-start ${
                isActive
                  ? 'bg-emerald-500 text-white shadow-emerald'
                  : 'text-gray-600 hover:bg-emerald-50 hover:text-emerald-700'
              }`}
            >
              <Icon size={18} className="flex-shrink-0" />
              <span className="hidden md:inline">{item.label}</span>
            </button>
          );
        })}
      </nav>

      {/* User Info */}
      <div className="p-2 md:p-4 border-t border-emerald-50">
        <div className="hidden md:flex items-center gap-3 mb-3">
          <div className="w-9 h-9 rounded-xl bg-emerald-100 flex items-center justify-center">
            <span className="text-emerald-700 font-bold text-sm">
              {user?.name?.charAt(0)?.toUpperCase()}
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-800 truncate">{user?.name}</p>
            <p className="text-xs text-emerald-600 capitalize">{user?.role}</p>
          </div>
        </div>
        <button
          data-testid="sidebar-logout-btn"
          onClick={handleLogout}
          title="Keluar"
          className="w-full flex items-center justify-center md:justify-start gap-2 px-2 md:px-3 py-2 rounded-xl text-sm text-red-500 hover:bg-red-50 transition-colors duration-200"
        >
          <LogOut size={16} className="flex-shrink-0" />
          <span className="hidden md:inline">Keluar</span>
        </button>
      </div>
    </aside>
  );
}
